<script >
// 容器相关
const {
  plugins: {
    ComplexComp
  }
} = require('@futuweb/fego-render');
import { CHILD_TYPE } from '../common/enum';
import LogoImg from '../children/logo-img/render/index.vue';
const __sfc_main = {
  mixins: [ComplexComp.Inner.Parent.Mixins({
    [CHILD_TYPE]: LogoImg
  })]
};
__sfc_main.props = {
  needTeleport: Boolean
};
__sfc_main.setup = (__props, __ctx) => {
  const props = __props;
  const {
    useTeleport
  } = require('@fegobull/webapi').use;
  props.needTeleport && useTeleport(window.document.body);
  return {};
};
export default __sfc_main;
</script>

<template>
    <div class="top-container__teleport">
        <slot></slot>
    </div>
</template>
